import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { mapLang } from './utils/langUtils';

const DEFAULT_LANG = 'en-US';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    debug: process.env.NODE_ENV !== 'production', // disabled in live envs
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang'
    },
    preprocess: mapLang
  }).then(() => {
    /**
     * mapLanguage call needed again, since the above init hook will only
     * set the selected language phrases (i.e. 'fr-CA' will show 'fr' phrases),
     * but it will _not_ set the active language, which is used to determine
     * the selected item in the language selection list in the app.
     */
    const mappedLang = mapLang(i18n.language);
    i18n.changeLanguage(mappedLang);
  });

export default i18n;
